import React, { createContext, useState, useEffect } from "react";
import { getCompanyData } from "../helpers/getCompanyData";

export const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(() => {
    const savedCompany = localStorage.getItem("companyData");
    return savedCompany ? JSON.parse(savedCompany) : null;
  });

  useEffect(() => {
    const fetchCompany = async () => {
      const data = await getCompanyData();
      if (data) {
        setCompany(data);
      }
    };

    fetchCompany();
  }, []);

  return (
    <CompanyContext.Provider value={{ company }}>
      {children}
    </CompanyContext.Provider>
  );
};
